// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfQuarter as fn } from "../endOfQuarter.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfQuarterWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default endOfQuarterWithOptions;
